import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { MessageTemplate } from "@idw-types/data/message-template";
import { MESSAGE_TEMPLATE_ID_PATTERN } from "@constants/url-parameter-patterns";

export const getMessageTemplateRequest = async (messageTemplateId: string): Promise<{ data: MessageTemplate, error: any }> => {
    const route = injectCustomIdParameter(apiRoutes.axnadminCore.data.messageTemplateWithId, messageTemplateId, MESSAGE_TEMPLATE_ID_PATTERN);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};